import React from "react";

import { useLocation } from "react-router";

import { Button } from "@at/design-system-elements";

import { TypeInsignia } from "@at/design-system-foundation";
import { LogoExperian } from "@at/design-system-icons";

import * as Styled from "./check-your-eligibility.styled";

import { useLeasingStateContext } from "../../../../../contexts/leasing/context/leasing.context";
import { useChannel } from "../../../../../utils/hooks/use-channel";
import { useTracking } from "../../../../../utils/tracking/use-tracking";
import {
  buildNewQueryString,
  buildUrlWithParams,
} from "../../../navigation/leasing-navigation.utils";
import { LeasingProductBordered } from "../../leasing-contract-customiser.styled";

export const CheckYourEligibility = () => {
  const routerLocation = useLocation();
  const { trackEvent } = useTracking();
  const channel = useChannel();
  const windowLocation = typeof window !== undefined && window.location;
  const { search } = windowLocation || routerLocation;
  const { selectedLeaseOffer, leaseContractType, productData, leaseOption } =
    useLeasingStateContext();

  const newSearchString = buildNewQueryString(
    search,
    productData?.id,
    leaseContractType,
    selectedLeaseOffer,
    leaseOption,
    "pdp",
  );

  const urlWithParams = buildUrlWithParams(
    newSearchString,
    `/${channel}/leasing/eligibility-checker`,
  );

  return (
    <LeasingProductBordered>
      <LogoExperian title="Experian logo" />
      <TypeInsignia as="h2" weight="400">
        Check how likely you are to be approved for lease credit
      </TypeInsignia>
      <Styled.CheckEligibilityContent>
        Get an instant result which lets you know how likely you are to be
        approved for lease credit before you start your application.
      </Styled.CheckEligibilityContent>
      <Button
        url={urlWithParams}
        text="Check my eligibility"
        displayType="secondary"
        data-gui="leasing-check-my-eligibility"
        onInteraction={() => {
          trackEvent({
            trackingLabel: "leasing-eligibility-checker-check-my-eligibility",
          });
        }}
      />
    </LeasingProductBordered>
  );
};
